/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateComponentTwinsGroupRequestDto
 */
export interface UpdateComponentTwinsGroupRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateComponentTwinsGroupRequestDto
     */
    groupName?: string;
    /**
     * Replacement member set; must contain at least two ids
     * @type {Array<string>}
     * @memberof UpdateComponentTwinsGroupRequestDto
     */
    componentTwinsIds?: Array<string>;
}

/**
 * Check if a given object implements the UpdateComponentTwinsGroupRequestDto interface.
 */
export function instanceOfUpdateComponentTwinsGroupRequestDto(value: object): value is UpdateComponentTwinsGroupRequestDto {
    return true;
}

export function UpdateComponentTwinsGroupRequestDtoFromJSON(json: any): UpdateComponentTwinsGroupRequestDto {
    return UpdateComponentTwinsGroupRequestDtoFromJSONTyped(json, false);
}

export function UpdateComponentTwinsGroupRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateComponentTwinsGroupRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'componentTwinsIds': json['componentTwinsIds'] == null ? undefined : json['componentTwinsIds'],
    };
}

export function UpdateComponentTwinsGroupRequestDtoToJSON(json: any): UpdateComponentTwinsGroupRequestDto {
    return UpdateComponentTwinsGroupRequestDtoToJSONTyped(json, false);
}

export function UpdateComponentTwinsGroupRequestDtoToJSONTyped(value?: UpdateComponentTwinsGroupRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groupName': value['groupName'],
        'componentTwinsIds': value['componentTwinsIds'],
    };
}

